import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { baseUrl } from '../../constants';

@Injectable({ providedIn: 'root' })
export class TodoService {
  private apiUrl = `${baseUrl}Todo`;

  constructor(private http: HttpClient) {}

  private get headers() {
    const token = localStorage.getItem('token');
    return {
      headers: new HttpHeaders({
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      })
    };
  }

  getMine(status?: string): Observable<any[]> {
    let params = new HttpParams();
    if (status && status !== 'all') params = params.set('status', status);
    return this.http.get<any[]>(`${this.apiUrl}/mine`, { ...this.headers, params });
  }

  getById(id: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/${id}`, this.headers);
  }

  create(payload: any): Observable<any> {
    return this.http.post<any>(this.apiUrl, payload, this.headers);
  }

  update(id: number, payload: any): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/${id}`, payload, this.headers);
  }

  getComments(id: number): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/${id}/comments`, this.headers);
  }

  addComment(id: number, payload: { comment: string }): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/${id}/comments`, payload, this.headers);
  }
}
